module.exports = __webpack_public_path__ + "img/youtube-icon.65fa13e2f191477114f3f78dd0c4259b.svg";